// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { TaskLogOutput } from 'thehive-sdk';
import { ResultCard } from '@Organisms/Search/SearchResultCard/ResultCard';
import { extractData } from './extractData';
import { useLocalMessage } from '@Helpers/locale';
import { ICONS } from '@Constants/iconsApp';

import './LogResultCard.scss';

interface LogResultCardProps {
    data?: TaskLogOutput;
}

export const LogResultCard = ({ data }: LogResultCardProps): ReactElement => {
    const i = useLocalMessage();

    const { _createdAt = 0, _createdBy = '', message = '' } = data || {};

    const title = `Message by ${_createdBy}`;

    return (
        <ResultCard
            data={{
                '#computeTitle': {
                    title,
                    icon: <ICONS.TaskLogIcon />,
                },
                '#computeDate': {
                    date: _createdAt,
                    _createdBy,
                },
                '#computeDescription': message,
            }}
            extract={extractData({ locale: i })}
        />
    );
};
